import { render } from "./ShopView.vue?vue&type=template&id=5ce66f1f&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"

import "./ShopView.vue?vue&type=style&index=0&id=5ce66f1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce66f1f"]])

export default __exports__